import gql from 'graphql-tag';

const SetUserMonthBonusMutation = gql`
  mutation SetUserMonthBonus($input: UserMonthBonusSetInput!) {
   user_month_bonus_set(input: $input) {
      id
    }
  }
`;


export const setUserMonthBonusApi = async (client, userMonthBonusesArray) => {
  const variables = {
    input: {
      user_month_bonuses: userMonthBonusesArray,
    },
  };


  const options = {
    mutation: SetUserMonthBonusMutation,
    variables,
  };

  const result = await client.mutate(options);
  return {
    result,

  };
};
